import React from 'react'
import ControlledModal from '../../../../components/modals/ControlledModal'
import ConfigsLoader from './_load/ConfigsLoader'
import ConfigsTable from './table/ConfigsTable'
import Header from './Header'

const ListServiceOrderAutomaticDistributionConfigModal = props => {
  return (
    <ControlledModal width="64rem" {...props}>
      <ConfigsLoader>
        <Header />
        <ConfigsTable />
      </ConfigsLoader>
    </ControlledModal>
  )
}

export default ListServiceOrderAutomaticDistributionConfigModal
